module.exports = __webpack_public_path__ + "img/logo.df9adf6a.svg";